<div>
  <div class="w-100 mx-auto" style="max-width: 500px">
    <mat-form-field appearance="fill" class="d-block">
      <mat-label>Plate Style</mat-label>
      <mat-select [(ngModel)]="plateStyle" (selectionChange)="plateStyleChanged($event)">
        <mat-option [value]="'dateless'">Dateless</mat-option>
        <mat-option [value]="'current'">Current</mat-option>
        <mat-option [value]="'prefix'">Prefix</mat-option>
        <mat-option [value]="'suffix'">Suffix</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="d-flex">
      <mat-form-field class="flex-fill me-1">
        <input matInput [(ngModel)]="platePrefix" placeholder="Prefix"/>
      </mat-form-field>
      <mat-form-field class="flex-fill me-1">
        <input matInput [(ngModel)]="plateNumbers" placeholder="Numbers"/>
      </mat-form-field>
      <mat-form-field class="flex-fill">
        <input matInput [(ngModel)]="plateLetters" placeholder="Letters"/>
      </mat-form-field>
    </div>
  </div>

  <div class="d-flex gap-2 justify-content-center align-items-center">
    <button class="d-block btn btn-lg btn-primary" (click)="searchPlates()">Search Plates</button>
    <button [disabled]="!results || results.length === 0" class="d-block btn btn-lg btn-outline-primary" (click)="exportResults()">Export</button>
  </div>

  <div class="text-center">
    <p class="my-0">For each portion of the plate you can enter wildcards.<br/>eg: prefix: '', numbers: '_0', letters:
      'OOO' will return [1-9]0 OOO<br/>prefix: '', numbers: '1', letters: 'O%' will return 1 O[A-ZZZ]</p>
    <p>Dont go crazy on wildcards else it wont return anything</p>
  </div>

  <div>
    <table mat-table [dataSource]="results" class="mt-3 w-100">

      <!-- Registration Column -->
      <ng-container matColumnDef="registration">
        <th mat-header-cell *matHeaderCellDef> Registration</th>
        <td mat-cell class="ps-0 pe-1" *matCellDef="let plate">
          <pla-plate [rawPlate]="plate.formattedRegistration" [showPrice]="false" [mobileSmall]="true"
                     [smallPlate]="false" [showPercentage]="false" [customClass]="'flat shaded'" [plateSize]="'smaller'"
                     [noMargin]="true" [openModal]="false"></pla-plate>
        </td>
      </ng-container>

      <!-- Sold Price Column -->
      <ng-container matColumnDef="sold_price">
        <th mat-header-cell *matHeaderCellDef> Sold Price</th>
        <td mat-cell class="ps-0 pe-1" *matCellDef="let plate"> {{ plate.sold_price / 100 | currency: 'GBP' }}</td>
      </ng-container>

      <!-- Sold Date Column -->
      <ng-container matColumnDef="sold_date">
        <th mat-header-cell *matHeaderCellDef> Sold Date</th>
        <td mat-cell class="ps-0 pe-1" *matCellDef="let plate"> {{ plate.sold_date | date: 'dd/MM/yyyy' }}</td>
      </ng-container>

      <!-- Seller Column -->
      <ng-container matColumnDef="seller">
        <th mat-header-cell *matHeaderCellDef> Seller</th>
        <td mat-cell class="px-0" *matCellDef="let plate">
          <ng-container [ngSwitch]="plate.sale_type">
            <span class="lh-sm" *ngSwitchCase="0">DVLA AUCTION (PRE SCRAPE)</span>
            <span class="lh-sm" *ngSwitchCase="1">DVLA SALE</span>
            <span class="lh-sm" *ngSwitchCase="2">PLATEX SALE</span>
            <span class="lh-sm" *ngSwitchCase="3">THIRD PARTY ({{ plate.seller }})</span>
            <span class="lh-sm" *ngSwitchCase="4">CURRENTLY LISTED</span>
            <span class="lh-sm" *ngSwitchCase="5">INITIAL PRICE</span>
            <span class="lh-sm" *ngSwitchCase="6">{{ plate.seller }}</span>
            <span class="lh-sm" *ngSwitchCase="7">THIRD PARTY AUCTION ({{plate.seller}})</span>
            <span class="lh-sm" *ngSwitchCase="8">PRICE CHANGE</span>
            <span class="lh-sm" *ngSwitchCase="9">CUSTOM SELLER ({{plate.seller}})</span>
            <span class="lh-sm" *ngSwitchCase="10">{{plate.seller}}</span>
            <span class="lh-sm" *ngSwitchCase="100">{{plate.seller}}</span>
            <span class="lh-sm" *ngSwitchDefault>UNKNOWN</span>
          </ng-container>
        </td>
      </ng-container>

      <!-- Header and Row Definitions -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</div>
